// extracted by mini-css-extract-plugin
export var hideEditor = "_kt-2";
export var infoIcon = "_kt-3";
export var label = "_kt-1";
export var labelContainer = "_kt-0";
export var readonlyText = "_kt-4";